module.exports = __webpack_public_path__ + "img/gateway.ec6d1d14.png";